<!-- 图片选择 -->
<template>
  <div class="picture-upload" title="发送图片" @click="selectAndUpload">
    <Icon :size="26" icon="ep:picture" class="cursor-pointer" />
  </div>
</template>

<script lang="ts" setup>
import * as FileApi from '@/api/infra/file'

defineOptions({ name: 'PictureSelectUpload' })

const message = useMessage() // 消息弹窗

/** 选择并上传文件 */
const emits = defineEmits<{
  (e: 'send-picture', v: string): void
}>()
const selectAndUpload = async () => {
  try {
    const files: any = await getFiles()
    if (!files?.length) {
      return
    }
    message.success('图片发送中请稍等。。。')
    const res = await FileApi.updateFile({ file: files[0].file })
    emits('send-picture', res.data)
  } catch (error: any) {
    if (error?.errorType === 'limit') {
      message.error('超出上传数量限制')
      return
    }
    if (error?.errorType === 'fileSize') {
      message.error('文件过大')
      return
    }
    console.error('选择文件出错:', error)
  }
}

/**
 * 唤起文件选择窗口，并获取选择的文件
 */
async function getFiles(options = {}) {
  const { multiple, accept, limit, fileSize } = {
    multiple: true,
    accept: 'image/jpeg, image/png, image/gif',
    limit: 1,
    fileSize: 500,
    ...options
  }

  const input = document.createElement('input')
  input.type = 'file'
  input.style.display = 'none'
  if (multiple) input.multiple = true
  if (accept) input.accept = accept
  document.body.appendChild(input)
  input.click()

  try {
    return await new Promise((resolve, reject) => {
      input.addEventListener('change', (event: any) => {
        const filesArray = Array.from(event?.target?.files || [])
        document.body.removeChild(input)

        if (filesArray.length > limit) {
          reject({ errorType: 'limit', files: filesArray })
          return
        }

        const overSizedFiles = filesArray.filter((file: File) => file.size / 1024 ** 2 > fileSize)
        if (overSizedFiles.length > 0) {
          reject({ errorType: 'fileSize', files: overSizedFiles })
          return
        }

        const fileList = filesArray.map((file, index) => ({ file, uid: Date.now() + index }))
        resolve(fileList)
      })
    })
  } catch (error) {
    if (document.body.contains(input)) {
      document.body.removeChild(input)
    }
    throw error
  }
}
</script>

<style lang="scss" scoped>
.picture-upload {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: var(--el-text-color-regular);
  line-height: 1;

  &:hover {
    color: var(--el-color-primary);
  }
}
</style>
